export const getCookieValue = name => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
  return '0'
}

export const setCookie = (name, value) => {
  // Set cookie to expire in 1 year
  const date = new Date()
  date.setFullYear(date.getFullYear() + 1)
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`
}
